import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IEmployeeState }        from 'Redux/Slices/Employee/EmployeeSlice';
import { Employee }              from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const updateEmployeeRequest = (state: Draft<IEmployeeState>, { type }: PayloadAction<{ id: string, formData: any }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.lastUpdateId = null;
  state.updatedAt = Date.now();
};

export const updateEmployeeSuccess = (state: Draft<IEmployeeState>, { type, payload }: PayloadAction<{
  employee: Employee
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.lastUpdateId = payload.employee.id;
  state.entries = { ...state.entries, [payload.employee.id]: payload.employee };
};

export const updateEmployeeFailure = (state: Draft<IEmployeeState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
